import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import * as WatershedActions from "src/app/store/watershed/actions";
import * as FromWatershed from "src/app/store/watershed/selectors";
import * as FromApp from "src/app/store/app/selectors";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { Observable, Subject, filter, first, takeUntil, tap, withLatestFrom } from "rxjs";
import { IslandDto } from "src/app/services/api";
import { TranslateService } from "@ngx-translate/core";
import { DataModeVariable } from "src/app/enums";
import { DataMode } from "src/app/interfaces";

@Component({
  selector: "app-islands",
  templateUrl: "./islands.component.html",
  styleUrls: ["./islands.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IslandsComponent {
  public dataModeVariable: typeof DataModeVariable = DataModeVariable;
  public readonly dataMode$: Observable<DataMode> = this.store.select(FromWatershed.selectDataMode);

  public readonly hoveredIslandId$: Observable<string> = this.store.select(FromWatershed.selectHoveredIslandId);
  public readonly islands$: Observable<IslandDto[]> = this.store.select(FromWatershed.selectIslands);
  public readonly islandId$: Observable<string> = this.store.select(FromWatershed.selectIslandId);

  public readonly refreshState$: Observable<boolean> = this.store.select(FromApp.selectRefreshState);

  private unsubscribeSubject$: Subject<void>;

  constructor(
    private readonly store: Store<RootState>,
    public readonly translateService: TranslateService,
  ) {}

  public ionViewWillEnter(): void {
    this.unsubscribeSubject$ = new Subject();

    this.islandId$
      .pipe(
        first(),
        filter(islandId => !islandId),
        withLatestFrom(this.islands$),
        tap(([, islands]) => {
          if (!islands || islands.length === 0) {
            this.store.dispatch(WatershedActions.loadIslands());
          }
        }),
      )
      .subscribe();

    this.refreshState$
      .pipe(
        takeUntil(this.unsubscribeSubject$),
        filter(refreshState => !!refreshState),
        withLatestFrom(this.islandId$),
        tap(([, islandId]) => {
          if (!islandId) this.store.dispatch(WatershedActions.loadIslands());
        }),
      )
      .subscribe();
  }

  public ionViewWillLeave(): void {
    this.unsubscribeSubject$.next();
    this.unsubscribeSubject$.complete();
  }

  public selectIsland(islandId: string | number): void {
    this.store.dispatch(WatershedActions.setIslandId({ islandId: islandId.toString() }));
  }

  public onMouseEnter(islandId: string | number): void {
    this.store.dispatch(WatershedActions.setHoveredIslandId({ islandId: islandId.toString(), hoveredIslandId: islandId.toString() }));
  }

  public onMouseLeave(islandId: string | number): void {
    this.store.dispatch(WatershedActions.setHoveredIslandId({ islandId: islandId.toString(), hoveredIslandId: null }));
  }
}
